import { useEffect, useState } from "react";
import { Modal, Button, Form, Row, Col, Spinner } from "react-bootstrap";
import BackMethods from "../../back_component/BackMethods";

function ModalHeaderPro({ title, onHide }) {
  return (
    <div className="users-admin-modal__header">
      <div className="users-admin-modal__header-main">
        <h5 className="users-admin-modal__title mb-0">{title}</h5>
      </div>
      <button type="button" className="btn-close" onClick={onHide} aria-label="إغلاق" />
    </div>
  );
}

function InlineField({ label, htmlFor, children }) {
  return (
    <div className="users-admin-modal__inline-field">
      <Form.Label htmlFor={htmlFor} className="users-admin-modal__inline-label">
        {label}
      </Form.Label>
      <div className="users-admin-modal__inline-control">{children}</div>
    </div>
  );
}

function CreatePriceSurveyProductModal({ show, onHide, onSaved, categories }) {
  const { backEnd_request } = BackMethods();
  const [form, setForm] = useState({
    name: "",
    categoryId: "",
    isActive: true,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formError, setFormError] = useState("");

  useEffect(() => {
    if (!show) return;
    setForm({ name: "", categoryId: "", isActive: true });
    setFormError("");
    setIsSubmitting(false);
  }, [show]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormError("");
    if (!form.name.trim()) {
      setFormError("يرجى إدخال اسم المنتج.");
      return;
    }
    if (!form.categoryId) {
      setFormError("يرجى اختيار التصنيف.");
      return;
    }
    setIsSubmitting(true);
    try {
      await backEnd_request.post("/PriceSurveyProducts", {
        name: form.name.trim(),
        categoryId: form.categoryId,
        isActive: form.isActive,
      });
      onSaved?.({ message: "تم إضافة المنتج بنجاح ✅", variant: "success" });
      onHide();
    } catch (err) {
      setFormError(err.response?.data?.message || "حدث خطأ أثناء الإضافة");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      dialogClassName="users-admin-modal-dialog"
      className="users-admin-modal users-admin-modal--compact"
      dir="rtl"
      backdrop="static"
    >
      <ModalHeaderPro title="إضافة منتج" onHide={onHide} />
      <Modal.Body>
        <p className="users-admin-modal__hint">
          <i className="bi bi-plus-circle" />
          <span>اختر التصنيف المناسب وحدد ما إذا كان المنتج نشطاً في استطلاع الأسعار.</span>
        </p>
        <Form onSubmit={handleSubmit}>
          <Row className="g-2 gx-lg-3">
            <Col md={12}>
              <InlineField label="اسم المنتج" htmlFor="psp-create-name">
                <Form.Control
                  id="psp-create-name"
                  size="sm"
                  className="rounded-2"
                  value={form.name}
                  onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))}
                />
              </InlineField>
            </Col>
            <Col md={12}>
              <InlineField label="تصنيف المادة" htmlFor="psp-create-category">
                <Form.Select
                  id="psp-create-category"
                  size="sm"
                  className="rounded-2"
                  value={form.categoryId === "" || form.categoryId == null ? "" : String(form.categoryId)}
                  onChange={(e) => setForm((p) => ({ ...p, categoryId: e.target.value }))}
                >
                  <option value="">اختر التصنيف...</option>
                  {(categories || []).map((cat) => (
                    <option key={cat.categoryId} value={String(cat.categoryId)}>
                      {cat.name}
                    </option>
                  ))}
                </Form.Select>
              </InlineField>
            </Col>
            <Col md={12}>
              <InlineField label="الحالة" htmlFor="psp-create-active">
                <Form.Check
                  type="switch"
                  id="psp-create-active"
                  label={form.isActive ? "نشط" : "متوقف"}
                  checked={form.isActive}
                  onChange={(e) => setForm((p) => ({ ...p, isActive: e.target.checked }))}
                />
              </InlineField>
            </Col>
          </Row>
          {formError ? (
            <div className="alert alert-danger py-1 px-2 small mb-0 mt-2" role="alert">
              {formError}
            </div>
          ) : null}
          <div className="users-admin-modal__footer d-flex gap-2 justify-content-end mt-3">
            <Button variant="outline-secondary" size="sm" type="button" onClick={onHide} disabled={isSubmitting}>
              إلغاء
            </Button>
            <Button variant="primary" size="sm" type="submit" disabled={isSubmitting}>
              {isSubmitting ? (
                <>
                  <Spinner animation="border" size="sm" className="ms-1" /> حفظ
                </>
              ) : (
                "إضافة المنتج"
              )}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

function EditPriceSurveyProductModal({ show, productId, initialProduct, onHide, onSaved, categories }) {
  const { backEnd_request } = BackMethods();
  const [form, setForm] = useState({
    name: "",
    categoryId: "",
    isActive: true,
  });
  const [initialName, setInitialName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formError, setFormError] = useState("");

  useEffect(() => {
    if (!show || !initialProduct || !productId) return;
    setFormError("");
    const n = initialProduct.name ?? "";
    setForm({
      name: n,
      categoryId:
        initialProduct.categoryId === "" || initialProduct.categoryId == null
          ? ""
          : String(initialProduct.categoryId),
      isActive: initialProduct.isActive ?? true,
    });
    setInitialName(n);
  }, [show, productId, initialProduct]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormError("");
    if (!form.name.trim()) {
      setFormError("يرجى إدخال اسم المنتج.");
      return;
    }
    if (!form.categoryId) {
      setFormError("يرجى اختيار التصنيف.");
      return;
    }
    setIsSubmitting(true);
    try {
      const payload = {
        ...initialProduct,
        name: form.name.trim(),
        categoryId: form.categoryId,
        isActive: form.isActive,
      };
      await backEnd_request.post(`/PriceSurveyProducts/${productId}`, payload);
      onSaved?.({ message: "تم تعديل المنتج بنجاح ✅", variant: "success" });
      onHide();
    } catch (err) {
      setFormError(err.response?.data?.message || "تعذر حفظ التعديلات");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      dialogClassName="users-admin-modal-dialog"
      className="users-admin-modal users-admin-modal--compact"
      dir="rtl"
      backdrop="static"
    >
      <ModalHeaderPro title="تعديل منتج" onHide={onHide} />
      <Modal.Body>
        {initialName ? (
          <div className="users-admin-modal__user-chip mb-2 py-1">
            <i className="bi bi-box-seam text-secondary small" />
            <span className="text-muted" style={{ fontSize: "0.75rem" }}>
              المنتج الحالي
            </span>
            <strong className="small">{initialName}</strong>
          </div>
        ) : null}
        <Form onSubmit={handleSubmit}>
          <Row className="g-2 gx-lg-3">
            <Col md={12}>
              <InlineField label="اسم المنتج" htmlFor="psp-edit-name">
                <Form.Control
                  id="psp-edit-name"
                  size="sm"
                  className="rounded-2"
                  value={form.name}
                  onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))}
                />
              </InlineField>
            </Col>
            <Col md={12}>
              <InlineField label="تصنيف المادة" htmlFor="psp-edit-category">
                <Form.Select
                  id="psp-edit-category"
                  size="sm"
                  className="rounded-2"
                  value={form.categoryId === "" || form.categoryId == null ? "" : String(form.categoryId)}
                  onChange={(e) => setForm((p) => ({ ...p, categoryId: e.target.value }))}
                >
                  <option value="">اختر التصنيف...</option>
                  {(categories || []).map((cat) => (
                    <option key={cat.categoryId} value={String(cat.categoryId)}>
                      {cat.name}
                    </option>
                  ))}
                </Form.Select>
              </InlineField>
            </Col>
            <Col md={12}>
              <InlineField label="الحالة" htmlFor="psp-edit-active">
                <Form.Check
                  type="switch"
                  id="psp-edit-active"
                  label={form.isActive ? "نشط" : "متوقف"}
                  checked={form.isActive}
                  onChange={(e) => setForm((p) => ({ ...p, isActive: e.target.checked }))}
                />
              </InlineField>
            </Col>
          </Row>
          {formError ? (
            <div className="alert alert-danger py-1 px-2 small mb-0 mt-2" role="alert">
              {formError}
            </div>
          ) : null}
          <div className="users-admin-modal__footer d-flex gap-2 justify-content-end mt-3">
            <Button variant="outline-secondary" size="sm" type="button" onClick={onHide} disabled={isSubmitting}>
              إلغاء
            </Button>
            <Button variant="primary" size="sm" type="submit" disabled={isSubmitting}>
              {isSubmitting ? (
                <>
                  <Spinner animation="border" size="sm" className="ms-1" /> حفظ
                </>
              ) : (
                "حفظ التغييرات"
              )}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default function PriceSurveyProductsModals({
  modal,
  productId,
  initialProduct,
  categories,
  onClose,
  onSaved,
}) {
  return (
    <>
      <CreatePriceSurveyProductModal show={modal === "create"} onHide={onClose} onSaved={onSaved} categories={categories} />
      <EditPriceSurveyProductModal
        show={modal === "edit"}
        productId={productId}
        initialProduct={initialProduct}
        onHide={onClose}
        onSaved={onSaved}
        categories={categories}
      />
    </>
  );
}
